<!--  Loader Ends -->
<!-- Main Body Starts -->
<div class="container-fluid login-two-container">
  <div class="row main-login-two">
    <div class="col-xl-6 col-lg-6 col-md-6 d-none d-md-block p-0">
      <div class="login-bg">
        <div class="left-content-area">
          <div class="card-content">
            <h2>{{ 'login.bannerText1' | translate }}</h2>
            <p>{{ 'login.bannerText2' | translate }}</p>
            <a
              class="btn mt-4 btn-login-info"
              href="https://safecloudsinglar.com/"
              target="_blank"
              type="button"
              >{{ 'login.bannerText3' | translate }}</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 p-0">
      <div
        class="login-two-start"
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100%;
        "
      >
        <div class="logo-container">
          <img
            class="logo-safecloud-1"
            src="../../assets/img/safecloud-1.png"
            alt="logo"
          />
        </div>
        <h6 class="right-bar-heading px-3 mt-2 text-dark text-center font-30">
          {{ 'login.newPassword' | translate }}
        </h6>
        <p
          *ngIf="!isForgotPassword"
          class="text-center text-muted mt-1 mb-3 font-14"
        >
          {{ 'login.enterTheNewAppPassword' | translate }}
        </p>
        <p
          *ngIf="isForgotPassword"
          class="text-center text-muted mt-1 mb-3 font-14"
        >
          {{ 'login.enterYourEmail' | translate }}
        </p>
        <form style="width: 80%; margin: 0 auto">
          <div class="reset-password-send-message" *ngIf="showMessageSendEmail">
            {{ 'login.resetPasswordSend' | translate }}
          </div>
          <div
            *ngIf="isForgotPassword"
            class="login-two-inputs mt-5 input-group"
          >
            <input
              type="email"
              class="form-control"
              [placeholder]="'login.email' | translate"
              [(ngModel)]="email"
              style="background-color: #fff !important"
            />
            <i class="las la-user-alt"></i>
            <div class="invalid-feedback" *ngFor="let error of passwordErrors">
              {{ error }}
            </div>
          </div>
          <div
            *ngIf="!isForgotPassword"
            class="login-two-inputs mt-4 input-group"
          >
            <input
              type="password"
              class="form-control"
              [placeholder]="'login.newPassword' | translate"
              style="background-color: #fff !important"
              [(ngModel)]="password"
            />
            <i class="las la-lock"></i>
            <div class="invalid-feedback" *ngFor="let error of passwordErrors">
              {{ error }}
            </div>
          </div>
          <div
            *ngIf="!isForgotPassword"
            class="login-two-inputs mt-4 input-group"
          >
            <input
              type="password"
              class="form-control"
              [placeholder]="'login.password' | translate"
              style="background-color: #fff !important"
              [(ngModel)]="confirmNewPassword"
            />
            <i class="las la-lock"></i>
            <div class="invalid-feedback" *ngFor="let error of passwordErrors">
              {{ error.description || error }}
            </div>
            <div
              class="invalid-feedback"
              *ngFor="let error of confirmPasswordErrors"
            >
              {{ error.description || error }}
            </div>
          </div>
          <div
            class="login-two-inputs mt-5 text-center d-flex"
            style="gap: 25px"
          >
            <button
              style="max-height: 40px; width: 50%"
              class="ripple-button ripple-button-primary w-100 btn-login"
              (click)="changePassword()"
              [disabled]="!buttonValidation"
              [ngStyle]="{
                'background-color': !buttonValidation ? '#ccc' : '',
                'text-shadow': !buttonValidation && 'none'
              }"
            >
              <div class="ripple-ripple js-ripple">
                <span class="ripple-ripple__circle"></span>
              </div>
              <span *ngIf="!isLoading && !isForgotPassword">{{
                'login.changePassword' | translate
              }}</span>
              <span *ngIf="!isLoading && isForgotPassword">{{
                'login.sendEmail' | translate
              }}</span>

              <div
                style="position: relative; top: -5px"
                class="d-flex justify-content-center loader"
                *ngIf="isLoading"
              >
                <div class="spinner-border" role="status">
                  <span class="sr-only">{{ 'login.loading' | translate }}</span>
                </div>
              </div>
            </button>
            <a
              class="btn btn-sm btn-outline-primary btn-login w-100"
              routerLink="../"
              type="button"
              style="width: 50%"
            >
              {{ 'login.login' | translate }}
            </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
